import { modals } from "@mantine/modals";
import { BASE_API_MASTER, BASE_API_POS, BASE_API_SIGN } from ".";
import Repository from "../helper/HttpHelper";
import { Flex, Text, Title } from "@mantine/core";
import Avvvatars from "avvvatars-react";
import HistoryProfile from "../../views/Func/CreateProfile/HistoryProfile/HistoryProfile";
import { MessageResponse } from "../../model/MessageResponse";
import { SelectListItem } from "../../model/SelectListItem";
import { SignRejectModel } from "../../model/SignRejectModel ";
import { SignAccessModel } from "../../model/SignAccessModel";
import { NotificationExtension } from "../extension/NotificationExtension";
export const _timerDelayClick: number = 3;
export const _timerDelaySearch: number = 1;
// export const repositoryPos = new Repository(BASE_API_POS);
//export const repositorySign = new Repository("http://localhost:5004");
export const repositorySign = new Repository(BASE_API_SIGN);
export const pagination = true;
export const paginationPageSize = 50;
export const paginationPageSizeSelector = [20, 50, 100];

export const signTypes = [
  { value: 0, label: "Duyệt" },
  { value: 1, label: "Ký ảnh" },
  { value: 2, label: "Ký số" },
  { value: 3, label: "Ký nháy" },
];
export const signTypesModel = [
  { value: 0, label: "Tài khoản" },
  { value: 1, label: "Chức danh" },
  { value: 2, label: "Gửi email (Không cần đăng nhập)" },
  // { value: 3, label: "Gửi SMS (Không cần đăng nhập)" },
];

export const getColorByType = (value: number) => {
  switch (value) {
    case 0:
      return "green"; // Duyệt
    case 1:
      return "blue"; // Ký ảnh
    case 2:
      return "#15aabf"; // Ký số
    case 3:
      return "purple"; // Ký nhánh
    default:
      return "gray"; // Mặc định cho các loại không xác định
  }
};

export function convertSignType(value: number): string {
  switch (value) {
    case 0:
      return "Duyệt";
    case 1:
      return "Ký ảnh";
    case 2:
      return "Ký số";
    case 3:
      return "Ký nháy";
    default:
      return "Không xác định"; // Trả về chuỗi này nếu giá trị không nằm trong các trường hợp đã định nghĩa
  }
}

export function getFormattedDateUTCPlus7(): string {
  const now = new Date();

  // Chuyển đổi sang UTC+7
  const options: Intl.DateTimeFormatOptions = {
    timeZone: "Asia/Bangkok", // Múi giờ UTC+7
    hour: "2-digit" as const, // Đảm bảo kiểu dữ liệu là chính xác
    minute: "2-digit" as const,
    second: "2-digit" as const,
    day: "2-digit" as const,
    month: "2-digit" as const,
    year: "numeric" as const,
  };

  const formattedDate = now.toLocaleString("vi-VN", options);

  return formattedDate.replace(",", ""); // Xóa dấu phẩy nếu có
}

// const workerUrl = new URL(
//   "pdfjs-dist/build/pdf.worker.min.js",
//   import.meta.url
// ).toString();

export const workerUrl = new URL(
  "//cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js",
  import.meta.url
).toString();

export const AvatarUtils = ({
  value,
  show = true,
}: {
  value: string;
  show?: boolean;
}) => {
  const cleanValue = value ? value.toString().replace(/[^a-zA-Z\s]/g, "") : "";
  const words = cleanValue.split(" ").filter(Boolean);
  const word2 = cleanValue.split("-").filter(Boolean);
  let displayValue = "";

  if (words.length > 0 && value.indexOf("-") < 0)
    displayValue =
      words[0].substring(0, 1) +
      (words.length > 1
        ? words[words.length - 1].substring(0, 1)
        : word2[0]?.substring(1, 2));
  else
    displayValue =
      word2[0]?.substring(0, 1) +
      (word2.length > 1
        ? word2[word2.length - 1].substring(0, 1)
        : word2[0]?.substring(1, 2));
  return (
    <Flex gap={15} align={"center"}>
      {cleanValue ? (
        <Avvvatars
          size={38}
          style="character"
          displayValue={displayValue}
          value={cleanValue}
        />
      ) : null}
      {show && <Text fw={600}>{value}</Text>}
    </Flex>
  );
};

export const openModelHistory = (ids: number | null) =>
  modals.openConfirmModal({
    title: <Title order={4}>Lịch sử phê duyệt</Title>,
    size: "100%",
    children: <HistoryProfile ids={ids} />,
    labels: { confirm: "Confirm", cancel: "Cancel" },
    confirmProps: { display: "none" },
    cancelProps: { display: "none" },
    onCancel: () => console.log("Cancel"),
    onConfirm: () => console.log("Confirmed"),
  });

//API gọi danh sách loại hồ sơ
export const fetchDataDocType = async () => {
  const response = await repositorySign.get<MessageResponse<SelectListItem[]>>(
    "/api/v1/TblDocType/get-select"
  );

  if (response && response.success) {
    return response.data;
  }
  return null;
};

//API gọi danh sách phòng ban
export const fetchDataDepartment = async () => {
  const response = await repositorySign.get<MessageResponse<SelectListItem[]>>(
    "api/v1/Department/get-select"
  );

  if (response && response.success) {
    return response.data;
  }
  return null;
};

export const rejectFlow = async (
  listStepId: number,
  setupId: number,
  onLoad?: any
) => {
  let entity: SignRejectModel = {
    listStepId: listStepId,
    setupId: setupId,
  };
  if (entity) {
    const urlApi = "/api/v1/SignPage/sign-reject";
    var resSign = await repositorySign.post<MessageResponse<SignAccessModel>>(
      urlApi,
      entity
    );
    if (resSign && resSign.httpStatusCode === 200) {
      if (resSign.success) {
        if (onLoad) await onLoad();
        NotificationExtension.Success("Thành công !");
      } else NotificationExtension.Fails(resSign.message ?? "Thất bại !");
    }
  } else NotificationExtension.Fails("Lỗi khi từ chối duyết !");
};

export const url403 = "/anonymous/403";

export const styleTable = {
  fontWeight: "600",
  fontSize: "12.5px",
  padding: "3px 10px",
};
export const pageTable = ["20", "50", "100"];

export const noCheckAuth: Array<string> = ["/profile","/method","/dashboard","/method/folders-task-old","/method/task-for-me"];
